import type { ResumeTypes } from "@/types";

export const resumeData: ResumeTypes.ResumeItem[] = [
	{
		date: {
			start: "4/2024",
		},
		title: "Senior Software Engineer",
		company: {
			name: "Klaviyo",
			link: "https://www.klaviyo.com",
			location: "Remote",
		},
		items: [
			"Designed and developed our internal IP Warming system that was used for brands as large as Fortune 500 companies. This system was used to warm up IP addresses for new customers and existing customers. (Patent Pending)",
		],
	},
	{
		date: {
			start: "2/2022",
			end: "4/2024",
		},
		title: "Software Engineer",
		company: {
			name: "Klaviyo",
			link: "https://www.klaviyo.com",
			location: "Remote",
		},
		description:
			"I joined a new greenfield team with the goal of building out our internal Email Delivery Platform. I was one of the first engineers on the team, and my main focus on this team was to integrate this new pipeline into our monolith, and to grow that volume.",
		items: [
			"Designed and developed an internal traffic splitting system to help internal teams pin a brand to any email vendor. This system had the flexibility to adjust traffic for an entire tier of IP Pools, the entire ESP, and more.",
			"Designed and developed an internal system to transfer volume from our primary ESP to our new internal mail pipeline. This system transitioned over 50,000 brands without any escalations or issues. From 0% to 100% of volume being sent through our new pipeline.",
		],
	},
	{
		date: {
			start: "4/2021",
			end: "2/2022",
		},
		title: "Deliverability & Compliance Technical Specialist",
		company: {
			name: "Klaviyo",
			link: "https://www.klaviyo.com",
			location: "Boston, MA",
		},
		description:
			"I balanced a dual role that was divided between Engineering and Email Deliverability & Compliance Analyst duties.",
		items: [
			"Built out an entire backend system to handle the generation, validation, and assignment of clicktracking domains.",
			"Worked alongside our data science team to develop an automated warming system for new customers. This was later patented by Klaviyo, where I was cited as an author. [Patent #: 20230376996, 12026742 & 11756073]",
			"Designed a script to automatically identify brands that were no longer sending enough volume to qualify for a Dedicated IP Address, to help save the business money.",
		],
	},
	{
		date: {
			start: "4/2019",
			end: "4/2021",
		},
		title: "Senior Deliverability & Compliance Specialist",
		company: {
			name: "Klaviyo",
			link: "https://www.klaviyo.com",
			location: "Boston, MA",
		},
		description: "",
		items: [
			"Onboarded a new Cloud ESP to handle the failover volume in the scenario our primary goes down. This involved warming up the new shared, and building out the other shared components (Sending Domain, Clicktracking, etc).",
			"Started working with our highest paying customers to build them out weekly Deliverability reports. That looked at a wide range of different trends around Email stats.",
		],
	},
	{
		date: {
			start: "6/2017",
			end: "4/2019",
		},
		title: "Deliverability & Compliance Specialist",
		company: {
			name: "Klaviyo",
			link: "https://www.klaviyo.com",
			location: "Boston, MA",
		},
		description: "Joined as the first Deliverability & Compliance team member.",
		items: [
			"Built out the foundation for future D&C Team members, processes, scenarios and documenting the caveats around our upstream providers.",
			"Worked with both Customers and internal members around Deliverability & Compliance challenges, and helped educated and remediate the issues.",
			"Redesigned our shared infrastructure to handle limitations of our upstream provider.",
			"Handled over 11,000 email cases in this role.",
		],
	},
];
